import { onBeforeUnmount, onMounted, ref } from 'vue'

/**
 * True below Bulma's tablet breakpoint (768px). For layout decisions that
 * cannot be made in CSS alone, such as rendering an inline form on desktop
 * and a separate page on a phone.
 */
export function useIsMobile() {
  const query = '(max-width: 767px)'
  const isMobile = ref(typeof window !== 'undefined' && window.matchMedia(query).matches)

  let media: MediaQueryList | null = null
  const onChange = (event: MediaQueryListEvent) => {
    isMobile.value = event.matches
  }

  onMounted(() => {
    media = window.matchMedia(query)
    isMobile.value = media.matches
    media.addEventListener('change', onChange)
  })

  onBeforeUnmount(() => {
    media?.removeEventListener('change', onChange)
  })

  return isMobile
}
